import { REGEX } from '@/utils/consts'
import { z } from 'zod'
import { inRange } from 'lodash-es'
import { getDeliveryAreas } from './apis'

export const carrierSchema = z.enum(['HJ', 'JA'])

export const addDeliveryAreaReqSchema = z
  .object({
    zipcode: z
      .string()
      .length(5, { message: '우편번호는 5자리로 입력해주세요.' })
      .regex(REGEX.positiveNumWithZero, { message: '우편번호는 숫자만 입력해주세요.' }),
    city: z.string().min(1),
    district: z
      .string()
      .min(1, { message: '한글자 이상 입력해주세요.' })
      .regex(REGEX.koreanAndNumber, { message: '한글, 한글+숫자만 입력 가능해요.' })
      .max(50, { message: '최대 50자까지 입력할 수 있어요.' })
      .nullable(),
    town: z
      .string()
      .min(1, { message: '한글자 이상 입력해주세요.' })
      .regex(REGEX.koreanAndNumber, { message: '한글, 한글+숫자만 입력 가능해요.' })
      .max(50, { message: '최대 50자까지 입력할 수 있어요.' }),
    deliveryLeadDay: z.number({ message: '숫자만 입력해주세요.' }),
    remoteArea: z.boolean(),
    isHolidayDeliveryAvailable: z.boolean(),
    defaultCarrier: carrierSchema,
    holidayCarrier: carrierSchema,
  })
  .superRefine((data, ctx) => {
    const { deliveryLeadDay, remoteArea } = data

    const { isValid, message } = checkDeliveryLeadDay({ deliveryLeadDay, remoteArea })

    if (!isValid) {
      ctx.addIssue({ path: ['deliveryLeadDay'], code: z.ZodIssueCode.custom, message })
    }
  })

export const checkZipCodeDuplication = async (
  zipcode: string,
): Promise<{
  isValid: boolean
  message: string
}> => {
  const res = await getDeliveryAreas({ zipcode: [zipcode], page: 0, size: 1 })

  return {
    isValid: !!zipcode && res.data.content.length === 0,
    message: '이미 사용중인 우편번호 입니다.',
  }
}

// 도서산간 0~9, 기본은 1~3
export const checkDeliveryLeadDay = ({
  deliveryLeadDay,
  remoteArea,
}: Pick<z.infer<typeof addDeliveryAreaReqSchema>, 'deliveryLeadDay' | 'remoteArea'>): {
  isValid: boolean
  message: string
} => {
  const range = remoteArea ? [0, 9] : [1, 3]

  return {
    isValid: inRange(deliveryLeadDay, range[0], range[1] + 1),
    message: `${range.join('~')} 사이로 입력해주세요.`,
  }
}
